import { VisibilityOutlined } from "@mui/icons-material";
import AddSharpIcon from "@mui/icons-material/AddSharp";
import { Button, Dropdown, DropdownButton, Form, Table } from "react-bootstrap";
import "../Dynamic/UserList.scss";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import MarkunreadOutlinedIcon from "@mui/icons-material/MarkunreadOutlined";
import StickyNote2Icon from "@mui/icons-material/StickyNote2";
import WarningIcon from '@mui/icons-material/Warning';
import {
  IconButton,
  Tooltip,
  Typography
} from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import React, { useEffect, useRef, useState, useLayoutEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { useHistory, useParams, useLocation } from "react-router";
import DownLoadIcon from '../../assets/images/icons/DownLoadIcon.svg';
import EditIcon from '../../assets/images/icons/EditIcon.svg';
import EditIconWhite from '../../assets/images/icons/EditIconWhite.svg';
import TrashIcon from "../../assets/images/icons/Trash.svg";
import Constant from "../../Constant";
import { CommonService } from "../../Service/CommonService";
import { CookieService } from "../../Service/CookieService";
import { InventoryApiService } from "../../Service/InventoryApiService";
import { MessageApiService } from "../../Service/MessageApiService";
import { OrderApiService } from "../../Service/OrderApiService";
import Customspinner from "../Common/CustomSpinner";
import { HistoryStepper } from "../Common/HistoryStepper";
import Spinner from "../Common/Spinner";
import StatusDropdown from "../Common/StatusDropdown";
import "../Dynamic/InventoryCSV.scss";
import "../Dynamic/UserList.scss";
import UploadDocs from "../popups/uploadDocs";
import AdminMessageBox from "./AdminMessageBox";
import BarrelSelectionPanel from "./BarrelSelectionPanel";
import ContainerMessageBox from "./ContainerMessageBox";
import EditRequest from "./EditOrderRequest";
import ViewProductDetail from "./ViewProductDetail";
import Select from "react-select";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";

const ViewSampleRequest: React.FC = () => {
  const history = useHistory();
  const location = useLocation();
  const { id } = useParams<{ id: string }>();
  const userRole = CookieService.getCookie("userRole");
  const [sampleRequest, setSampleRequest] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [sampleRequestDocs, setSampleRequestDocs] = useState<any[]>([]);
  const [historyData, setHistoryData] = useState<any[]>([]);
  const [isApproved, setIsApproved] = useState(false);
  const [rejectionNoteValue, setNote] = useState<string>("");
  const [trackNumberValue, setTrackNumber] = useState<string>("");
  const [selectedWarehouseUser, setSelectedWarehouseUser] = useState<string>("");
  const [error, setError] = useState<string>("");
  const [isOpenEditSection, setOpenEditSection] = useState(false);
  const [isMessageBoxOpen, setMessageBoxOpen] = useState(false);
  const [ownerStatus, setOwnerStatus] = useState("");
  const [isSeller, setIsSeller] = useState<boolean>(false);
  const [show, setShow] = useState(false);
  const [isOwnerRejected, setOwnerRejected] = useState(false);
  const rejectionNote = useRef("");
  const trackNumber = useRef("");
  const [isSpinner, setIsSpinner] = useState(false);
  const [ownerRejectionNote, setOwnerRejectionNote] = useState("");
  const [viewDetails, setViewDetails] = useState(false);
  const handleViewClose = () => setViewDetails((prev) => !prev);  
  const [isBeforeCancel, setIsBeforeCancel] = useState(false);
  const [isAfterCancel, setIsAfterCancel] = useState(false);
  const [files, setFiles] = useState<File[]>([]);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [isInWarehouse, setIsInWarehouse] = useState(false);
  const [warehouseUserList, setWarehouseUserList] = useState([]);  
  const statusDetailsRef = useRef({
    id: "",
    inventoryId: "",
    sampleRequestStatus: "",
    trackNumber: "",
    rejectionNote: "",
    assignedTo: ""
  });
  const handleShow = () => setShow(true);
  const [showMessageBox, setShowMessageBox] = useState(false);
  const [unreadGroupsCount, setUnreadGroupsCount] = React.useState<number>(0);
  const [unreadMessageCount, setUnreadMessageCount] = React.useState<number>(0);
  const handleClose = () => {
    setShow(false);
    setNote("");
    setTrackNumber("");
    setIsAfterCancel(false);
    setIsApproved(false);
    setRequestRejected(false);
    setOwnerRejected(false);
    setFiles([]);
    setOwnerRejectionNote("");
    setSelectedWarehouseUser("");
    setError("");
  };
  const [viewBarrelSelection, setViewBarrelSelection] = useState(false);
  const [totalAvailableBarrelsCount, setTotalAvailableBarrelsCount] = useState(0);
  const [totalReservedBarrelsCount, setTotalReservedBarrelCount] = useState(0);
  const [isNotEnoughBarrels, setIsNotEnoughBarrels] = useState(false);
  const [isRequestRejected, setRequestRejected] = useState(false);

//  useEffect(() => {
//   if (window.innerWidth > 1200) {
//     if (viewDetails) {
//       document.body.style.overflow = "hidden";
//     } else {
//       document.body.style.overflow = "auto";
//     }
//   }

//   return () => {
//     document.body.style.overflow = "auto";
//   };
// }, [viewDetails]);

  // Dynamic Height Calculation Start
    const [wrapperHeight, setWrapperHeight] = useState(0);
  const wrapperRef = useRef<HTMLDivElement>(null);
  
  const updateWrapperHeight = () => {
    if (wrapperRef.current) {
      setWrapperHeight(wrapperRef.current.clientHeight);
      console.log("Wrapper Height:", wrapperRef.current.clientHeight);
    }
  };
  
  // Run on mount, after layout updates
  useLayoutEffect(() => {
    setTimeout(updateWrapperHeight, 0);
  }, []);
  
  // Run when isLoading changes
  useEffect(() => {
    if (!isLoading) {
      setTimeout(updateWrapperHeight, 0); // Delay to ensure DOM updates
    }
  }, [isLoading]);
  
  // Run on window resize
  useEffect(() => {
    const handleResize = () => updateWrapperHeight();
    window.addEventListener("resize", handleResize);
    
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const [innerHeight, setInnerHeight] = useState(0);
    const innerRef = useRef<HTMLDivElement>(null);
  
    // Function to update height
    const updateHeight = () => {
      if (innerRef.current) {
        setInnerHeight(innerRef.current.clientHeight);
      }
    };
  
    useEffect(() => {
      // Update height on mount and resize
      updateHeight();
      window.addEventListener("resize", updateHeight);
      
      return () => {
        window.removeEventListener("resize", updateHeight);
      };
    }, []);
    // Recalculate height when the message box visibility changes
    useEffect(() => {
      if (showMessageBox) {
        // Wait for DOM to update (small delay ensures correct height calculation)
        setTimeout(updateHeight, 0);
      }
    }, [showMessageBox]); // Runs every time showMessageBox changes
  // Dynamic Height Calculation End

  const handleShowBarrelSelection = () => setViewBarrelSelection(true);

    

  const handleCloseBarrelSelection = () => {
    setViewBarrelSelection(false);

    fetchTotalAvailableBarrelCount(sampleRequest?.inventoryId);
    fetchTotalReservedBarrelCount();
  }

   // Fetches the total available barrel count for a given group
  const fetchTotalAvailableBarrelCount = async (inventoryId: string) => {
    setIsSpinner(true);
    try {
      const response = await InventoryApiService.getAllBarrelsCount(inventoryId);
      setTotalAvailableBarrelsCount(response?.data);
    } catch (error) {
      console.error('Error fetching available container count:', error);
    } finally {
      setIsSpinner(false);
    }
  };

  //Fetches the total reserved barrel count
  const fetchTotalReservedBarrelCount = async () => {
    setIsSpinner(true);
    try {
      const response = await OrderApiService.getReservedBarrelsCountForSampleRequest(id);
      setTotalReservedBarrelCount(response?.data);
    } catch (error) {
      console.error('Error fetching reserved container count:', error);
    } finally {
      setIsSpinner(false);
    }
  };

  // Define the localeText object based on the isLoading flag
  const localeText = {
    noRowsLabel: isLoading ? "Fetching records ..." : "No Record Found",
  };
  const routeBack = () => {
    if (
      history.action === "PUSH" ||
      history.action === "REPLACE" ||
      (location.state && (location.state as any).fromInternal)
    ) {
      history.goBack();
    } else {
      if (CommonService.isUser()) history.push("/user/sample-request");
      else if (CommonService.isWarehouse()) history.goBack();
      else if(document.referrer.includes('/master/all-request')) history.goBack();
      else history.push("/master/sample-request");
    }
  };

  const fetchData = async () => {
    try {
      fetchSampleRequestDetail();
      fetchSampleRequestDocs();
      fetchSampleRequestHistory();
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchSampleRequestDetail = async () => {

    try{
      const response: any = await OrderApiService.fetchSampleRequestById(id);
      setSampleRequest(response.data);
      const hasSeller =
        !CommonService.isSameCompany(response.data?.companyId) &&
        CommonService.isUser()
          ? true
          : false;
      setIsSeller(hasSeller);

      // Handle admin-specific data fetching
      if (CommonService.isAdmin() || CommonService.isWarehouse()) {
        await fetchTotalAvailableBarrelCount(response?.data?.inventoryId);
          
        const isNotReviewStatus = response?.data?.status !== "PENDING_REVIEW" && 
                                   response?.data?.status !== "UNDER_REVIEW";
        if (isNotReviewStatus) {
          await fetchTotalReservedBarrelCount();
        }
      }
      
    } catch (error) {
      console.error('Error fetching sample request details:', error);
    } finally {
      setIsLoading(false);
    }
   
  };

  const fetchSampleRequestDocs = async () => {
    setIsLoading(true);
    const response: any = await OrderApiService.fetchSampleRequestDocs(id);
    setSampleRequestDocs(response.data);
    setIsLoading(false);
  };

  const fetchSampleRequestHistory = async () => {
    const response: any = await OrderApiService.fetchSampleRequestHistory(id);
    setHistoryData(response.data);
  };

  const getAdminUnreadMessageGroupsCount = async () => {
    try {
      const response = await MessageApiService.getAdminMessageGroups(
        id,
        "SAMPLE_REQUEST"
      );

      setUnreadGroupsCount(response.data.unreadGroupsCount);
      setUnreadMessageCount(response.data.unreadMessageCount);
    } catch (error) {
      console.log("error fetching Admin Message Groups Count" + error);
    }
  };

  useEffect(() => {
    fetchData();
    if (CommonService.isAdmin()) getAdminUnreadMessageGroupsCount();
  }, []);

  const handleStatusChange = async (requestStatus: string) => {
    const sampleRequestStatus = requestStatus?.replace(/[\s-]/g, "_");

    //create the object to send
    const sd = {
      id: id,
      inventoryId: sampleRequest.inventoryId,
      sampleRequestStatus: sampleRequestStatus.toUpperCase(),
      companyId: CommonService.getCompanyId(),
      trackNumber: "",
      rejectionNote: "",
      assignedTo: selectedWarehouseUser
    };

    statusDetailsRef.current = sd;
    if (statusDetailsRef.current.sampleRequestStatus === Constant.SampleRequestStatus.ACCEPTED && totalAvailableBarrelsCount < 1) {
      setIsNotEnoughBarrels(true);
      CommonService.Toast.fire({
        title: "Out of stock. No container in this inventory",
        icon: "error",
      });
      return;
      
    } else if(statusDetailsRef.current.sampleRequestStatus == Constant.SampleRequestStatus.IN_TRANSIT && totalReservedBarrelsCount == 0) {
      CommonService.Toast.fire({
        title: "At least one barrel must be selected for In Transit status.",
        icon: "error",
      });
      handleClose();
      return;
    } else if (statusDetailsRef.current.sampleRequestStatus === Constant.SampleRequestStatus.REJECTED) {
      setRequestRejected(true);
      setIsApproved(false);
      handleShow();
    } else if (statusDetailsRef.current.sampleRequestStatus === Constant.SampleRequestStatus.IN_TRANSIT) {
      setIsApproved(true);
      handleShow();
    } else if (statusDetailsRef.current.sampleRequestStatus === Constant.SampleRequestStatus.SEND_TO_WAREHOUSE) {
      setIsInWarehouse(true);
      let response = await OrderApiService.fetchAllWarehouseUser();
      setWarehouseUserList(response.data);
      handleShow();
    } else if (statusDetailsRef.current.sampleRequestStatus === Constant.SampleRequestStatus.CANCELLED) {
        if(["PENDING_REVIEW", "UNDER_REVIEW"].includes(sampleRequest.sampleRequestStatus)){
          setIsBeforeCancel(true);
          setIsAfterCancel(false);
        }else if(["ACCEPTED", "IN_PROGRESS", "INVOICE_SENT", "PAYMENT_RECEIVED"].includes(sampleRequest.sampleRequestStatus)){
          setIsAfterCancel(true);
          setIsBeforeCancel(false);
        }
      handleShow();
    } else if (["ACCEPTED", "IN_PROGRESS", "INVOICE_SENT", "PAYMENT_RECEIVED", "CLOSED"].includes(statusDetailsRef.current.sampleRequestStatus)) {
      setIsApproved(false);
      setIsAfterCancel(false);
      setIsBeforeCancel(false);
      setIsInWarehouse(false);
      handleShow();
    } else {
      //if status is not ACCEPTED and REJECTED then call method don't open any popup
      changeSampleRequestStatus();
    }
  };

  const changeSampleRequestStatus = async () => {
    if (statusDetailsRef.current.sampleRequestStatus === Constant.SampleRequestStatus.REJECTED && 
      rejectionNoteValue.trim().length === 0) {
      setError("Please enter rejection note");
      return;
    }

    if (statusDetailsRef.current.sampleRequestStatus === Constant.SampleRequestStatus.IN_TRANSIT &&
      trackNumberValue.trim().length === 0) {
      setError("Please enter track number");
      return;
    }

    if(statusDetailsRef.current.sampleRequestStatus === Constant.SampleRequestStatus.SEND_TO_WAREHOUSE && selectedWarehouseUser == "") {
      setError("Please Select Warehouse");
      return;
    }

    if(statusDetailsRef.current.sampleRequestStatus == Constant.SampleRequestStatus.ACCEPTED && totalAvailableBarrelsCount < 1) {
      setIsNotEnoughBarrels(true);
      CommonService.Toast.fire({
        title: "Out of Stock, please change quantity",
        icon: "error",
      });
      return;
    }


    setIsSpinner(true);
    try {
      if (statusDetailsRef.current.sampleRequestStatus === Constant.SampleRequestStatus.REJECTED
         || statusDetailsRef.current.sampleRequestStatus === Constant.SampleRequestStatus.CANCELLED) {
        statusDetailsRef.current.rejectionNote = rejectionNote.current;
      } else if (statusDetailsRef.current.sampleRequestStatus === Constant.SampleRequestStatus.IN_TRANSIT) {
        statusDetailsRef.current.trackNumber = trackNumber.current;
      } else if (statusDetailsRef.current.sampleRequestStatus === Constant.SampleRequestStatus.SEND_TO_WAREHOUSE) {
        statusDetailsRef.current.assignedTo = selectedWarehouseUser;
      }

      await OrderApiService.changeSampleRequestStatus(statusDetailsRef.current);
      setIsSpinner(false);
      CommonService.Toast.fire({
        title: "Sample Request updated successfully",
        icon: "success",
      });

      handleClose();
      fetchSampleRequestDetail();
      fetchSampleRequestHistory();

      if (statusDetailsRef.current.sampleRequestStatus === Constant.SampleRequestStatus.IN_TRANSIT
         && (files.length > 0)) {
        uploadSampleRequestDocs();
      }
    } catch (error) {
      console.log("error occurred which api calling");
      setIsSpinner(false);
      handleClose();
      if(statusDetailsRef.current.sampleRequestStatus === Constant.SampleRequestStatus.IN_TRANSIT) {
        CommonService.Toast.fire({
          title: `${error?.response?.data?.errorMessage}`,
          icon: "error",
        });
      }
      
    }
  };

  const statusMappings = {
    "Send to Owner": "PENDING_REVIEW",
    "Accept for Owner": "ADMIN_ACCEPTED",
    "Reject for Owner": "ADMIN_REJECTED",
  };

  const handleOwnerStatusChange = async (ownerStatus: any) => {
    ownerStatus = statusMappings[ownerStatus] || ownerStatus;
    const sampleOwnerStatus = ownerStatus?.replace(/ /g, "_").toUpperCase();

    setOwnerStatus(sampleOwnerStatus);

    if (
      sampleOwnerStatus == "ADMIN_REJECTED" ||
      sampleOwnerStatus == "REJECTED"
    ) {
      setOwnerRejected(true);
      return;
    }

    //create the object to send
    const requestData = {
      id: id,
      inventoryId: sampleRequest.inventoryId,
      ownerStatus: sampleOwnerStatus.toUpperCase(),
      companyId: CommonService.getCompanyId(),
    };

    try {
      await OrderApiService.updateSampleRequestOwnerStatus(requestData);
      setIsSpinner(false);
      CommonService.Toast.fire({
        title: "Owner status updated successfully",
        icon: "success",
      });
      // handleClose();

      fetchSampleRequestDetail();
      fetchSampleRequestHistory();
    } catch (error) {
      console.log("error occurred which api calling");
    }
  };

  const changeSampleRequestOwnerStatus = async () => {
    //perform the validation of owner rejection note
    if (!ownerRejectionNote || ownerRejectionNote?.trim() == "") {
      setError("Please enter rejection note");
      return;
    }

    setIsSpinner(true);

    //create the object to send
    const requestData = {
      id: id,
      inventoryId: sampleRequest.inventoryId,
      ownerStatus: ownerStatus,
      ownerRejectionNote: ownerRejectionNote,
      companyId: CommonService.getCompanyId(),
    };

    try {
      await OrderApiService.updateSampleRequestOwnerStatus(requestData);
      setIsSpinner(false);
      CommonService.Toast.fire({
        title: "Owner status updated successfully",
        icon: "success",
      });
      handleClose();
      fetchSampleRequestDetail();
    } catch (error) {
      console.log("error occurred which api calling");
      setIsSpinner(false);
    }
  };

  //handle edit button click
  const handleEditButtonClick = () => {
    if (isOpenEditSection) {
      setOpenEditSection(false);
    } else {
      setMessageBoxOpen(false);
      setShowMessageBox(false); // close admin message box while click on edit icon
      setOpenEditSection(true);
    }
  };

  //handle message box click
  const handleMessageBoxClick = () => {
    if (isMessageBoxOpen) {
      setMessageBoxOpen(false);
    } else {
      setOpenEditSection(false);
      setMessageBoxOpen(true);
      updateHeight();
      updateWrapperHeight();
    }
  };

  const handleAdminMessageClick = () => {

    if (showMessageBox) {
      setShowMessageBox(false);
    } else {
      setOpenEditSection(false);
      setShowMessageBox(true);
    }

    // Reset unread groups count when the message box is toggled
    setUnreadGroupsCount(
      unreadGroupsCount > 0 && unreadMessageCount > 0
        ? unreadGroupsCount - 1
        : unreadGroupsCount
    );
  };

  function formatStatus(status?: string): string {
    let formattedStatus = "";
    if (status !== undefined) {
      formattedStatus = status
        ?.split(/[_\\]/)
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join(" ");
    }
    return formattedStatus;
  }


  function formatStatusWithHyphen(status?: string): string {
    let formattedStatus = "";
    if (status !== undefined) {
      formattedStatus = status
        ?.split(/[_\\]/)
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join("-");
    }
    return formattedStatus;
  }

  const handleInputChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setError("");
    if (statusDetailsRef.current.sampleRequestStatus === Constant.SampleRequestStatus.REJECTED || 
      statusDetailsRef.current.sampleRequestStatus === Constant.SampleRequestStatus.CANCELLED
    ) {
      setNote(event.target.value);
      rejectionNote.current = event.target.value;
    } else {
      setTrackNumber(event.target.value);
      trackNumber.current = event.target.value;
    }
  };

  const handleWarehouseUserChange = (selectedOption) => {
    setSelectedWarehouseUser(selectedOption ? selectedOption.value : '');
    setError("");
  };

  const handleOwnerRejectionNote = (
    event: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    setError("");
    setOwnerRejectionNote(event.target.value);
  };

  const downloadSampleRequestDOC = async (item: any) => {
    const requestDto = {
      id: item.id,
      siteId: sampleRequest.siteId,
      companyId: item.companyId,
      fileName: item.fileName,
      requestNumber: sampleRequest?.requestNumber
    };

    try {
      const response: any = await OrderApiService.downloadSampleRequestDOC(
        requestDto
      );
      // Assuming response.data is the blob data
      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      a.download = item.fileName.includes("_") ? item.fileName.split("_").slice(1).join("_") : item.fileName;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const columnsForDoc: GridColDef[] = [
    {
      field: "createdDate",
      headerName: "Submitted On",
      flex: 1,
      minWidth:140,
      valueGetter: (value: any, row: any) => {
        const dateTimeString = row.createdDate ? row.createdDate : null;
        if (dateTimeString) {
          //call the method which formate the time
          return CommonService.formatDateTime(dateTimeString);
        }
      },
      headerClassName: "table-header",
    },
    {
      field: "fileName",
      headerName: "File Name",
      flex: 1,
      minWidth:140,
      valueGetter: (value: any, row: any) => {
        const fileName = row.fileName || "";
        return fileName.includes("_") ? fileName.split("_").slice(1).join("_") : fileName;
      },
      headerClassName: "table-header",
      renderCell: (params) => <CellWithTooltip value={params.value} />,
    },
    {
      field: "user",
      headerName: "Submitted By",
      flex: 1,
      minWidth:140,
      valueGetter: (value: any, row: any) =>
        `${row.firstName || ""} ${row.lastName || ""}`,
      headerClassName: "table-header",
      renderCell: (params) => <CellWithTooltip value={params.value} />,
    },
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      minWidth:140,
      sortable: false,
      width: 200,
      headerClassName: "table-header",
      renderCell: (params: any) => {
        //check file have .pdf extension or not
        const isPdf = params.row.fileName.toLowerCase().endsWith(".pdf");

        return (
        <div>

              {isPdf && (
                        <Tooltip title="View PDF" arrow>
                          <IconButton
                            onClick={() =>
                              CommonService.showPdf(
                                params.row.id,
                                params.row.companyId,
                                sampleRequest.siteId,
                                params.row.fileName,
                                Constant.RequestType.SAMPLE_REQUEST,
                                sampleRequest?.requestNumber
                              )
                            }
                          >
                            <VisibilityOutlined />
                          </IconButton>
                        </Tooltip>
                      )}
          <Tooltip title="Download document" arrow>
            <IconButton
              onClick={(event) => downloadSampleRequestDOC(params.row)}
            >
              {/* <CloudDownloadOutlinedIcon /> */}
              <img className="cursor-pointer" 
                          src={DownLoadIcon}
                          alt="EditIcon"
                        />
            </IconButton>
          </Tooltip>
        </div>
       );
     },
   }
 ];

  const CellWithTooltip = ({ value }: { value: string | number }) => {
    return (
      <Tooltip arrow title={value?.toString()}>
        <span>{value?.toString()}</span>
      </Tooltip>
    );
  };

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleDeleteFile = (indexToDelete: number) => {
    setFiles((prevFiles) =>
      prevFiles.filter((_, index) => index !== indexToDelete)
    );
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {

      const newFiles = Array.from(event.target.files);
      setFiles((prevFiles) => [...prevFiles, ...newFiles]);

      // Clear the input value to allow selecting the same file again
      event.target.value = "";
    }
  };

  const uploadSampleRequestDocs = async () => {

    const formData = new FormData();
    let response;
    let SampleRequestDoc = {};

    if (files && Array.isArray(files)) {
      files.forEach(function (file: any) {
        formData.append("file", file);
      });
    }

    const fileNames = files.map((file) => file.name).join(", ");

    SampleRequestDoc = {
      sampleRequestId: id,
      description: "uploaded " + fileNames + " document",
      userId: CommonService.getUserId(),
      title: fileNames,
      companyId: CommonService.getCompanyId(),
    };

    formData.append(
      "param",
      new Blob([JSON.stringify(SampleRequestDoc)], {
        type: "application/json",
      })
    );

    response = await OrderApiService.uploadSampleRequestDocs(formData);

    fetchSampleRequestDocs();
  };

  return (
    <>
      <div className="usersList position-relative">
        <div className="usersList__header--wrapper detail-page-header--wrapper d-flex">
        {(CommonService.isAdmin() || CommonService.isWarehouse())&& (
          <div className="usersList__header--inner d-flex justify-content-between gap-4">
            <div className="d-flex align-items-center gap-1"> 
            <div className="back__button me-1" onClick={routeBack}>
              <IconButton
                aria-label="ArrowBackIcon"
                sx={{ backgroundColor: "#FFF", }}
              >
                <ArrowBackIcon sx={{ color: "#1C1B1F" }} />
              </IconButton>
            </div>
            <div className="header--title me-3">
              <h1 className="title mb-0 text-nowrap">
                Sample Request Details
                <i className="bi bi-heart-fill"></i>
              </h1>
            </div>
            </div>
          </div>
        )}
<div className="d-flex align-items-center flex-column flex-lg-row justify-content-lg-between w-100 gap-2 gap-lg-0">
          <div className="header--title d-flex flex-wrap me-auto mb-xxl-0 gap-2 gap-xxl-3">
            <div className="time__details me-3 me-xl-4 mb-0">
              <Typography
                variant="h6"
                sx={{ color: "#333333", fontSize: "12px", fontWeight: 400 }}
              >
                Request Number
              </Typography>
              <Typography
                variant="h3"
                sx={{ color: "#333333", fontSize: "18px", fontWeight: 700 }}
              >
                #{sampleRequest?.requestNumber}
              </Typography>
            </div>
            {CommonService.isAdmin() && (
                <div className="company__details me-3 me-xl-4 mb-0">
                  <Typography
                    variant="h6"
                    sx={{ color: "#333333", fontSize: "12px", fontWeight: 400 }}
                  >
                    Account owner name
                  </Typography>
                  <Typography
                    variant="h3"
                    sx={{
                      color: "#333333",
                      fontSize: { xl: "18px", xs: "16px" },
                      fontWeight: 700,
                    }}
                  >
                    {sampleRequest?.companyName}
                  </Typography>
                </div>
            )}

            {(CommonService.isAdmin() || CommonService.isSameCompany(sampleRequest?.companyId)) && (
                <div className="person__details me-3 me-xl-4 mb-0">
                  <Typography
                    variant="h6"
                    sx={{ color: "#333333", fontSize: "12px", fontWeight: 400 }}
                  >
                    Requested  by
                  </Typography>
                  <Typography
                    variant="h3"
                    sx={{ color: "#333333", fontSize: "18px", fontWeight: 700 }}
                  >
                    {sampleRequest?.firstName}
                  </Typography>
                </div>
            )}

            <div className="time__details me-3 me-xl-4 mb-0">
              <Typography
                variant="h6"
                sx={{ color: "#333333", fontSize: "12px", fontWeight: 400 }}
              >
                Requested on
              </Typography>
              <Typography
                variant="h3"
                sx={{ color: "#333333", fontSize: "18px", fontWeight: 700 }}
              >
                {!isSeller
                  ? CommonService.formatDateTime(sampleRequest?.createdDate)
                  : CommonService.formatDateTime(sampleRequest?.ownerCreatedDate)}
              </Typography>
            </div>
            {( sampleRequest?.trackNumber && !isSeller &&
              <div className="time__details me-3 me-xl-4 mb-0">
                <Typography
                  variant="h6"
                  sx={{ color: "#333333", fontSize: "12px", fontWeight: 400 }}
                >
                  Track Number
                </Typography>
                <Typography
                  variant="h3"
                  sx={{ color: "#333333", fontSize: "18px", fontWeight: 700 }}
                >
                  {sampleRequest?.trackNumber}
                </Typography>
              </div>
            )}
            <div className="time__details me-3 me-xl-4 mb-0">
                <Typography
                  variant="h6"
                  sx={{ color: "#333333", fontSize: "12px", fontWeight: 400 }}
                >
                  Status
                </Typography>
                <Typography
                  variant="h3"
                  sx={{ color: "#333333", fontSize: "18px", fontWeight: 700 }}
                >
                  {/* Pending Review - User */}
              {(["PENDING_REVIEW", "UNDER_REVIEW", "ACCEPTED", "IN_PROGRESS", "INVOICE_SENT", "PAYMENT_RECEIVED", "IN_TRANSIT", "REJECTED"].includes(sampleRequest?.sampleRequestStatus) 
                  || sampleRequest?.sampleRequestStatus === "ACCEPTED_REJECTED") &&
                CommonService.isUser() && (
                  <StatusDropdown
                    currentStatus={formatStatus(
                      sampleRequest?.sampleRequestStatus
                    )}
                    onStatusChange={(newStatus) =>
                      handleStatusChange(newStatus)
                    }
                    disableCondition={
                      CommonService.isAdmin() || (!CommonService.isSameUser(sampleRequest?.createdBy) && CommonService.getRole() === Constant.Role.USER) ||
                      !CommonService.isSameCompany(sampleRequest?.companyId) ||
                      ["IN_TRANSIT", "REJECTED"].includes(sampleRequest?.sampleRequestStatus)
                    }
                    allowedLabels={["Cancelled"]}
                  />
                )}

              {/* Pending Review or Under Review - Admin */}
              {(sampleRequest?.sampleRequestStatus === "PENDING_REVIEW" ||
                sampleRequest?.sampleRequestStatus === "UNDER_REVIEW") &&
                CommonService.isAdmin() && (
                  <StatusDropdown
                    currentStatus={formatStatus(
                      sampleRequest?.sampleRequestStatus
                    )}
                    onStatusChange={(newStatus) =>
                      handleStatusChange(newStatus)
                    }
                    disableCondition={
                      CommonService.isUser() ||
                      sampleRequest?.sampleRequestStatus === "CANCELLED" ||
                      sampleRequest?.sampleRequestStatus === "REJECTED" 
                    }
                    allowedLabels={
                      sampleRequest?.hasValidStatus
                        ? ["Under Review", "Rejected"]
                        : sampleRequest?.hasItemRejected
                        ? ["Under Review", "Rejected"]
                        : ["Under Review", "Accepted", "Rejected"]
                    }
                  />
                )}

              {/* Accepted to Payment Received - Both User and Admin */}
              {["ACCEPTED","IN_PROGRESS", "REJECTED", "INVOICE_SENT"].includes(
                sampleRequest?.sampleRequestStatus
              ) && CommonService.isAdmin() && (
                <StatusDropdown
                  currentStatus={formatStatus(
                    sampleRequest?.sampleRequestStatus
                  )}
                  onStatusChange={(newStatus) => handleStatusChange(newStatus)}
                  disableCondition={
                    CommonService.isUser() ||
                    sampleRequest?.sampleRequestStatus === "CANCELLED" ||
                    sampleRequest?.sampleRequestStatus === "REJECTED"
                  }
                  allowedLabels={[
                    "In Progress",
                    "Invoice Sent",
                    "Payment Received",
                    "Rejected"
                  ]}
                />
              )}

              {sampleRequest?.sampleRequestStatus === "PAYMENT_RECEIVED" && CommonService.isAdmin() &&  (
                <StatusDropdown
                  currentStatus={formatStatus(
                    sampleRequest?.sampleRequestStatus
                  )}
                  onStatusChange={(newStatus) => {
                    handleStatusChange(newStatus);
                  }}
                  disableCondition={CommonService.isWarehouse() || CommonService.isUser()}
                  allowedLabels={["Send to Warehouse"]}
                />
              )}

              {["SEND_TO_WAREHOUSE", "IN_PROCESS"].includes(sampleRequest?.sampleRequestStatus) && (
                <StatusDropdown
                  currentStatus={formatStatus(
                    sampleRequest?.sampleRequestStatus
                  )}
                  onStatusChange={(newStatus) => {
                    handleStatusChange(newStatus);
                  }}
                  disableCondition={CommonService.isUser()}
                  allowedLabels={
                    CommonService.isAdmin()
                      ? [
                        "Admin Accepted for Warehouse"
                      ]
                      : [
                        "In Process",
                        "Reassign to Admin",
                        "Warehouse Completed"
                      ]
                  }
                />
              )}

              {["ADMIN_ACCEPTED_FOR_WAREHOUSE", "REASSIGN_TO_ADMIN", "WAREHOUSE_COMPLETED"].includes(sampleRequest?.sampleRequestStatus) && (
                <StatusDropdown
                  currentStatus={formatStatus(
                    sampleRequest?.sampleRequestStatus
                  )}
                  onStatusChange={(newStatus) => {
                    handleStatusChange(newStatus);
                  }}
                  disableCondition={CommonService.isUser() || CommonService.isWarehouse()}
                  allowedLabels={[
                    ...(sampleRequest?.sampleRequestStatus === "REASSIGN_TO_ADMIN") ? ["Send to Warehouse"] : [],
                    , "In Transit"]}
                />
              )}

              {sampleRequest?.sampleRequestStatus === "IN_TRANSIT" && (CommonService.isAdmin() || CommonService.isWarehouse()) && (
                <StatusDropdown
                  currentStatus={formatStatus(
                    sampleRequest?.sampleRequestStatus
                  )}
                  onStatusChange={(newStatus) => {
                    handleStatusChange(newStatus);
                  }}
                  disableCondition={CommonService.isUser() || CommonService.isWarehouse()}
                  allowedLabels={["Re-Processing","Closed"]}
                />
              )}

            {sampleRequest?.sampleRequestStatus === "RE_PROCESSING" && (
                <StatusDropdown
                  currentStatus={formatStatusWithHyphen(
                    sampleRequest?.sampleRequestStatus
                  )}
                  onStatusChange={(newStatus) => {
                    handleStatusChange(newStatus);
                  }}
                  disableCondition={CommonService.isUser() || CommonService.isWarehouse()}
                  allowedLabels={["In Transit","Rejected"]}
                />
              )}

              {(sampleRequest?.sampleRequestStatus === "DELIVERED" ||
                sampleRequest?.sampleRequestStatus === "CLOSED") && (
                <StatusDropdown
                  currentStatus={formatStatus(
                    sampleRequest?.sampleRequestStatus
                  )}
                  onStatusChange={(newStatus) => {
                    handleStatusChange(newStatus);
                  }}
                  disableCondition={true}
                  allowedLabels={[]}
                />
              )}

            {(sampleRequest?.sampleRequestStatus === "CANCELLED") && (
                <StatusDropdown
                  currentStatus={formatStatus(
                    sampleRequest?.sampleRequestStatus
                  )}
                  onStatusChange={(newStatus) => {
                    handleStatusChange(newStatus);
                  }}
                  disableCondition={CommonService.isUser() || CommonService.isWarehouse()}
                  allowedLabels={['Closed']}
                />
              )}

              {sampleRequest?.rejectionNote && (sampleRequest?.sampleRequestStatus === "REJECTED" || sampleRequest?.sampleRequestStatus === "CANCELLED" ) && (
                <Tooltip
                  title={`Rejection Note: ${sampleRequest?.rejectionNote}`}
                  arrow
                >
                  <StickyNote2Icon
                    className="note-icon cursor-pointer"
                    style={{ color: "gray" }}
                  />
                </Tooltip>
              )}
                </Typography>
              </div>
          </div>
          
          <div className="header--menu ms-auto mb-xxl-0">
            <div className="header--menu-items">

              {!CommonService.isWarehouse() && <Tooltip title="Messages" arrow>
                <IconButton
                  aria-label="message"
                  size="small"
                  onClick={
                    CommonService.isAdmin()
                      ? handleAdminMessageClick
                      : handleMessageBoxClick
                  }
                  sx={{
                    borderRadius: "50%",
                    backgroundColor: isMessageBoxOpen ? "#97AEB8" : "#FFF",
                    color: isMessageBoxOpen ? "#FFF" : "#1C1B1F",
                    marginInline: "8px",
                    padding: "8px",
                  }}
                >
                  <MarkunreadOutlinedIcon />
                  {unreadGroupsCount != 0 && CommonService.isAdmin() && (
                    <div className="msg-count-wrapper">{unreadGroupsCount}</div>
                  )}
                  {showMessageBox && <ArrowDropUpIcon className="arrow-icon" />}
                </IconButton>
              </Tooltip>}

              {/* {showMessageBox && (
                <div className="admin-message-box">
                  <div
                    className="admin-message-box-left-inner"
                    onClick={handleAdminMessageClick}
                  ></div>
                  <div className="admin-message-box-inner positio-relative">
                    <AdminMessageBox
                      selectedGroup={""}
                      requestId={id}
                      requestType={"SAMPLE_REQUEST"}
                      unreadGroupsCount={unreadGroupsCount}
                      setUnreadGroupsCount={setUnreadGroupsCount}
                      isSeller={isSeller}
                    />
                  </div>
                </div>
              )} */}
              {/* Pending Review - User */}
              {/* {(["PENDING_REVIEW", "UNDER_REVIEW", "ACCEPTED", "IN_PROGRESS", "INVOICE_SENT", "PAYMENT_RECEIVED", "IN_TRANSIT", "REJECTED"].includes(sampleRequest?.sampleRequestStatus) 
                  || sampleRequest?.sampleRequestStatus === "ACCEPTED_REJECTED") &&
                CommonService.isUser() && (
                  <StatusDropdown
                    currentStatus={formatStatus(
                      sampleRequest?.sampleRequestStatus
                    )}
                    onStatusChange={(newStatus) =>
                      handleStatusChange(newStatus)
                    }
                    disableCondition={
                      CommonService.isAdmin() || (!CommonService.isSameUser(sampleRequest?.createdBy) && CommonService.getRole() === Constant.Role.USER) ||
                      !CommonService.isSameCompany(sampleRequest?.companyId) ||
                      ["IN_TRANSIT", "REJECTED"].includes(sampleRequest?.sampleRequestStatus)
                    }
                    allowedLabels={["Cancelled"]}
                  />
                )} */}

              {/* Pending Review or Under Review - Admin */}
              {/* {(sampleRequest?.sampleRequestStatus === "PENDING_REVIEW" ||
                sampleRequest?.sampleRequestStatus === "UNDER_REVIEW") &&
                CommonService.isAdmin() && (
                  <StatusDropdown
                    currentStatus={formatStatus(
                      sampleRequest?.sampleRequestStatus
                    )}
                    onStatusChange={(newStatus) =>
                      handleStatusChange(newStatus)
                    }
                    disableCondition={
                      CommonService.isUser() ||
                      sampleRequest?.sampleRequestStatus === "CANCELLED" ||
                      sampleRequest?.sampleRequestStatus === "REJECTED" 
                    }
                    allowedLabels={
                      sampleRequest?.hasValidStatus
                        ? ["Under Review", "Rejected"]
                        : sampleRequest?.hasItemRejected
                        ? ["Under Review", "Rejected"]
                        : ["Under Review", "Accepted", "Rejected"]
                    }
                  />
                )} */}

              {/* Accepted to Payment Received - Both User and Admin */}
              {/* {["ACCEPTED","IN_PROGRESS", "REJECTED", "INVOICE_SENT", "PAYMENT_RECEIVED"].includes(
                sampleRequest?.sampleRequestStatus
              ) && CommonService.isAdmin() && (
                <StatusDropdown
                  currentStatus={formatStatus(
                    sampleRequest?.sampleRequestStatus
                  )}
                  onStatusChange={(newStatus) => handleStatusChange(newStatus)}
                  disableCondition={
                    CommonService.isUser() ||
                    sampleRequest?.sampleRequestStatus === "CANCELLED" ||
                    sampleRequest?.sampleRequestStatus === "REJECTED"
                  }
                  allowedLabels={[
                    "In Progress",
                    "Invoice Sent",
                    "Payment Received",
                    "In Transit",
                    "Rejected"
                  ]}
                />
              )} */}

              {/* {sampleRequest?.sampleRequestStatus === "IN_TRANSIT" && CommonService.isAdmin() && (
                <StatusDropdown
                  currentStatus={formatStatus(
                    sampleRequest?.sampleRequestStatus
                  )}
                  onStatusChange={(newStatus) => {
                    handleStatusChange(newStatus);
                  }}
                  disableCondition={CommonService.isUser()}
                  allowedLabels={["Re-Processing","Closed"]}
                />
              )}

            {sampleRequest?.sampleRequestStatus === "RE_PROCESSING" && (
                <StatusDropdown
                  currentStatus={formatStatusWithHyphen(
                    sampleRequest?.sampleRequestStatus
                  )}
                  onStatusChange={(newStatus) => {
                    handleStatusChange(newStatus);
                  }}
                  disableCondition={CommonService.isUser()}
                  allowedLabels={["In Transit","Rejected"]}
                />
              )}

              {(sampleRequest?.sampleRequestStatus === "DELIVERED" ||
                sampleRequest?.sampleRequestStatus === "CLOSED") && (
                <StatusDropdown
                  currentStatus={formatStatus(
                    sampleRequest?.sampleRequestStatus
                  )}
                  onStatusChange={(newStatus) => {
                    handleStatusChange(newStatus);
                  }}
                  disableCondition={true}
                  allowedLabels={[]}
                />
              )}

            {(sampleRequest?.sampleRequestStatus === "CANCELLED") && (
                <StatusDropdown
                  currentStatus={formatStatus(
                    sampleRequest?.sampleRequestStatus
                  )}
                  onStatusChange={(newStatus) => {
                    handleStatusChange(newStatus);
                  }}
                  disableCondition={CommonService.isUser()}
                  allowedLabels={['Closed']}
                />
              )}

              {sampleRequest?.rejectionNote && (sampleRequest?.sampleRequestStatus === "REJECTED" || sampleRequest?.sampleRequestStatus === "CANCELLED" ) && (
                <Tooltip
                  title={`Rejection Note: ${sampleRequest?.rejectionNote}`}
                  arrow
                >
                  <StickyNote2Icon
                    className="note-icon cursor-pointer"
                    style={{ color: "gray" }}
                  />
                </Tooltip>
              )} */}

{((sampleRequest?.status === "PENDING_REVIEW" || sampleRequest?.status === "UNDER_REVIEW") && (CommonService.isAdmin() 
                || (CommonService.isSameCompany(sampleRequest?.companyId) && CommonService.getRole() === Constant.Role.ADMIN && sampleRequest?.ownerStatus === 'ACTION_REQUIRED')
                || (CommonService.isSameUser(sampleRequest?.createdBy) && sampleRequest?.ownerStatus === 'ACTION_REQUIRED')))
                && (
                  <Tooltip title="Edit" arrow>
                    <IconButton
                        aria-label="message"
                        size="small"
                        onClick={handleEditButtonClick}
                        sx={{ borderRadius: "50%", backgroundColor: isOpenEditSection
                          ? "#97AEB8" // When only `isOpenEditSection` is true
                          : "#fff", color: "#1C1B1F", marginInline: "8px", padding: "8px" }}

                    >
                      {isOpenEditSection
                ? <img className="cursor-pointer" 
                src={EditIconWhite}
                alt="EditIconWhite"
              />:<img className="cursor-pointer" 
              src={EditIcon}
              alt="EditIcon"
            />
              }
                        
                        
                    </IconButton>
                  </Tooltip>
              )}
            </div>
          </div>
          </div>
        </div>
        <div className="viewSampleRequest--wrapper view_request--wrapper view_sample-wrapper viewOrderRequest--wrapper" ref={wrapperRef}>
          <div
            className={`${
              isOpenEditSection
                ? "margin-right-400" // When only `isOpenEditSection` is true
                : isMessageBoxOpen
                ? "margin-right-400" // Only `isMessageBoxOpen` is true
                : "no-margin w-100" // When none of the conditions are met
            }`}
          >
            <div className="view-sample-request">
              {/* <div className="row m-0">
                <div className="col-sm-6 col-lg-4">
                  <div className="sample-request-faq py-3">
                    <div className="faq-title position-relative pb-1 mb-3">
                      Purpose
                      <div className="ul-title d-inline-block position-absolute top-100 start-0"></div>
                    </div>
                    <div className="faq-desc">{sampleRequest?.purpose}</div>
                  </div>
                </div>
                <div className="col-sm-6 col-lg-4">
                  <div className="sample-request-faq py-3">
                    <div className="faq-title position-relative pb-1 mb-3">
                      Is Multiple container from same lot?
                      <div className="ul-title d-inline-block position-absolute top-100 start-0"></div>
                    </div>
                    <div className="faq-desc">
                      {sampleRequest?.multipleBarrels ? "Yes" : "No"}
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 col-lg-4">
                  <div className="sample-request-faq py-3">
                    <div className="faq-title position-relative pb-1 mb-3">
                      Is Multiple lots needed?
                      <div className="ul-title d-inline-block position-absolute top-100 start-0"></div>
                    </div>
                    <div className="faq-desc">
                      {sampleRequest?.multiplelots ? "Yes" : "No"}
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 col-lg-4">
                  <div className="sample-request-faq py-3">
                    <div className="faq-title position-relative pb-1 mb-3">
                      Size Needed
                      <div className="ul-title d-inline-block position-absolute top-100 start-0"></div>
                    </div>
                    <div className="faq-desc">{sampleRequest?.size}</div>
                  </div>
                </div>
                <div className="col-sm-6 col-lg-4">
                  <div className="sample-request-faq py-3">
                    <div className="faq-title position-relative pb-1 mb-3">
                      Qty Requested of Size
                      <div className="ul-title d-inline-block position-absolute top-100 start-0"></div>
                    </div>
                    <div className="faq-desc">{sampleRequest?.quantity}</div>
                  </div>
                </div>
                {CommonService.isAdmin() && (<><div className="col-sm-6 col-lg-4">
                  <div className="sample-request-faq py-3">
                    <div className="faq-title position-relative pb-1 mb-3">
                      Request Notes
                      <div className="ul-title d-inline-block position-absolute top-100 start-0"></div>
                    </div>
                    <div className="faq-desc">{sampleRequest?.comment}</div>
                  </div>
                </div><div className="col-sm-6 col-lg-4">
                    <div className="sample-request-faq py-3">
                      <div className="faq-title position-relative pb-1 mb-3">
                        Owner Status
                        <div className="ul-title d-inline-block position-absolute top-100 start-0"></div>
                      </div>
                      <div className="faq-desc">
                        {sampleRequest?.ownerStatus}
                      </div>
                    </div>
                  </div></>)}
              </div> */}
              <div className="row m-0">
                <div className="col-12 px-0">
                  <div>
                    <div>
                      <div className="inventory-file-list-table">
                        <div className="table-responsive-lg table-responsive-fixed-header">
                          {/* {!sampleRequest ? (
                            <Skeleton
                              animation="wave"
                              variant="rounded"
                              // height={550}
                              style={{ height: "100%" }}
                            />
                          ) : ( */}
                            <Table className="orderRequest-inv-table text-center">
                              <thead>
                                <tr>
                                  <th className="text-nowrap text-start">
                                    Inventory
                                  </th>
                                  <th className="text-nowrap text-center">
                                    Purpose
                                  </th>
                                  <th className="text-nowrap text-center">
                                    Is Multiple container from same lot?
                                  </th>
                                  <th className="text-nowrap text-center">
                                    Is Multiple lots needed?
                                  </th>
                                  <th className="text-nowrap text-center">
                                    Size Needed
                                  </th>
                                  <th className="text-nowrap text-center">
                                    Qty Requested of Size
                                  </th>
                                  <th className="text-nowrap text-center">
                                    Request Notes
                                  </th>
                                  {(isSeller || CommonService.isAdmin()) && (
                                    <th className="text-nowrap text-center">
                                      Owner Status
                                    </th>
                                  )}
                                  {/* <th className="text-nowrap text-center">
                                    Action
                                  </th> */}
                                </tr>
                              </thead>
                              <tbody>
                                {sampleRequest ? (
                                  <tr>
                                    <td className="text-start cursor-pointer" onClick={() => {
                                            handleViewClose();
                                          }}>
                                      <span className="inventory-name">{sampleRequest?.inventoryName}</span>
                                      <Typography
                                        component="p"
                                        sx={{
                                          color: "#737376",
                                          fontSize: "13px",
                                          fontWeight: "400",
                                          lineHeight: "21.28px",
                                        }}
                                      >
                                        {CommonService.isAdmin() &&  
                                          sampleRequest?.inventoryOwnerCompanyName
                                        }
                                      </Typography>
                                    </td>
                                    <td className="text-center">
                                      {sampleRequest?.purpose}
                                    </td>
                                    <td className="text-nowrap text-center">
                                      {sampleRequest?.multipleBarrels ? (
                                        <>
                                          <CheckIcon
                                            fontSize="small"
                                            sx={{ color: "#25CD25" }}
                                          />{" "}
                                          Yes
                                        </>
                                      ) : (
                                        <>
                                          <CloseIcon
                                            fontSize="small"
                                            sx={{ color: "#FF3B30" }}
                                          />{" "}
                                          No
                                        </>
                                      )}
                                    </td>
                                    <td className="text-nowrap text-center">
                                      {sampleRequest?.multiplelots ? (
                                        <>
                                          <CheckIcon
                                            fontSize="small"
                                            sx={{ color: "#25CD25" }}
                                          />{" "}
                                          Yes
                                        </>
                                      ) : (
                                        <>
                                          <CloseIcon
                                            fontSize="small"
                                            sx={{ color: "#FF3B30" }}
                                          />{" "}
                                          No
                                        </>
                                      )}
                                    </td>
                                    <td className="text-nowrap text-center">
                                      {sampleRequest?.size}
                                    </td>
                                    <td className="text-nowrap position-relative text-center d-flex flex-column align-items-center">
                                      {sampleRequest?.quantity}

                                      {(CommonService.isAdmin() || CommonService.isWarehouse()) && (!['PENDING_REVIEW','UNDER_REVIEW',"REJECTED"].includes(sampleRequest?.status))  && (<>
                                      {totalReservedBarrelsCount == 0 ? (<button
                                          onClick={handleShowBarrelSelection}
                                          className="reserve-barrel-btn ps-0"
                                          style={{ marginLeft: "-4px" }}
                                          >
                                          <AddSharpIcon /> Select Container
                                      </button>) : (
                                      <button
                                        onClick={handleShowBarrelSelection}
                                        className="reserve-barrel-btn ps-0"
                                      >
                                        {totalReservedBarrelsCount} {totalReservedBarrelsCount > 1 ? "Barrels Selected" : "Barrel Selected"}
                                      </button>
                                  
                                      )}

                                      </>)}
                                      

                                      {totalAvailableBarrelsCount < 1 && isNotEnoughBarrels && (CommonService.isAdmin() || CommonService.isWarehouse()) && (
                                      <span
                                          className="barrel-error"
                                          style={{
                                            bottom: totalAvailableBarrelsCount > 0 ? "-40px" : "-25px"
                                          }}
                                        >
                                          <WarningIcon /> Out of stock. No container in this inventory
                                        </span>
                                    )}
                                    </td>
                                    <td className="text-center">
                                      {sampleRequest?.comment}
                                    </td>
                                    {(isSeller || CommonService.isAdmin()) && (
                                      <>
                                        <td className="text-nowrap text-center">
                                          {CommonService.isAdmin() && (
                                            <StatusDropdown
                                              currentStatus={formatStatus(
                                                sampleRequest?.ownerStatus
                                              )}
                                              onStatusChange={(newStatus) =>
                                                handleOwnerStatusChange(
                                                  newStatus
                                                )
                                              }
                                              disableCondition={
                                                CommonService.isSameCompany(
                                                  sampleRequest?.companyId
                                                ) ||
                                                [
                                                  "REJECTED",
                                                  "ADMIN_REJECTED",
                                                  "ACCEPTED",
                                                ].includes(
                                                  sampleRequest?.ownerStatus
                                                ) ||
                                                [
                                                  "ACCEPTED",
                                                  "REJECTED",
                                                  "IN_PROGRESS",
                                                  "INVOICE_SENT",
                                                  "PAYMENT_RECEIVED",
                                                  "IN_TRANSIT",
                                                  "CANCELLED",
                                                  "CLOSED"
                                                ].includes(
                                                  sampleRequest?.status
                                                )
                                              }
                                              allowedLabels={
                                                sampleRequest?.ownerStatus ===
                                                "ADMIN_ACCEPTED"
                                                  ? ["Reject for Owner"]
                                                  : sampleRequest?.ownerStatus ===
                                                    "PENDING_REVIEW"
                                                  ? [
                                                      "Reject for Owner",
                                                      "Accept for Owner",
                                                    ]
                                                  : [
                                                      "Reject for Owner",
                                                      "Accept for Owner",
                                                      "Send to Owner",
                                                    ]
                                              }
                                            />
                                          )}

                                          {CommonService.isUser() && (
                                            <StatusDropdown
                                              currentStatus={formatStatus(
                                                sampleRequest?.ownerStatus
                                              )}
                                              onStatusChange={(newStatus) =>
                                                handleOwnerStatusChange(
                                                  newStatus
                                                )
                                              }
                                              disableCondition={
                                                CommonService.isSameCompany(
                                                  sampleRequest?.companyId
                                                ) ||
                                                [
                                                  "REJECTED",
                                                  "ADMIN_REJECTED",
                                                ].includes(
                                                  sampleRequest?.ownerStatus
                                                ) ||
                                                [
                                                  "ACCEPTED",
                                                  "REJECTED",
                                                  "IN_PROGRESS",
                                                  "INVOICE_SENT",
                                                  "PAYMENT_RECEIVED",
                                                  "IN_TRANSIT",
                                                  "CANCELLED",
                                                  "CLOSED"
                                                ].includes(
                                                  sampleRequest?.status
                                                )
                                              }
                                              allowedLabels={
                                                sampleRequest?.ownerStatus ===
                                                "ADMIN_ACCEPTED"
                                                  ? ["Rejected"]
                                                  : ["Accepted", "Rejected"]
                                              }
                                            />
                                          )}

                                          {(sampleRequest?.ownerStatus ===
                                            "REJECTED" ||
                                            sampleRequest?.ownerStatus ===
                                              "ADMIN_REJECTED") && (
                                            <Tooltip
                                              title={`Rejection Note: ${sampleRequest.ownerRejectionNote}`}
                                              arrow
                                            >
                                              <StickyNote2Icon
                                                className="note-icon cursor-pointer"
                                                style={{ color: "gray" }}
                                              />
                                            </Tooltip>
                                          )}
                                        </td>
                                      </>
                                    )}
                                    {/* <td className="text-nowrap text-center">
                                      <div className="d-flex justify-content-center gap-3">
                                        {(sampleRequest?.sampleRequestStatus ===
                                          "PENDING_REVIEW" ||
                                          sampleRequest?.sampleRequestStatus ===
                                            "UNDER_REVIEW") && (
                                          <BorderColorIcon
                                            onClick={handleEditButtonClick}
                                            className="cursor-pointer"
                                          />
                                        )}
                                        <VisibilityOutlined
                                          onClick={() => {
                                            handleViewClose();
                                          }}
                                          className="cursor-pointer"
                                        />
                                      </div>
                                    </td> */}
                                  </tr>
                                ) : (
                                  <tr>
                                    {/* <td colSpan={12} className="text-center">
                                      Fetching records ...
                                    </td> */}
                                    <td colSpan={12} style={{ textAlign: 'center' }} className='border-0'>
                                      {/* Fetching records... */}
                                      <div style={{ height: "222px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                        <Customspinner />
                                      </div>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </Table>
                          {/* )} */}
                        </div>
                        {viewDetails && (
                          <ViewProductDetail
                            handleViewClose={handleViewClose}
                            inventoryId={sampleRequest?.inventoryId}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              </div>
              <div className="row m-0">
                <div className="col-xl-6 mb-3 mb-xl-0 ps-0 pe-xl-2 pe-0">
                  <div className="orderDetail-footer-content-wrapper">
                    <div className="title-bar d-flex justify-content-between align-items-center mb-3">
                      <h3 className="mb-0">List of Documents</h3>
                      <UploadDocs
                        fetchData={fetchData}
                        csvId={id}
                        uploadCSV={false}
                        requestType={"SAMPLE_REQUEST"}
                        requestNumber = {sampleRequest?.requestNumber}
                      />
                    </div>
                    <div
                      className="inventory-doc-table"
                      // style={{ height: 350, width: "100%" }}
                    >
                      {/* {isLoading ? (
                        <>
                          <Skeleton
                            animation="wave"
                            variant="rounded"
                            // height={550}
                            style={{ height: "100%" }}
                          />
                        </>
                      ) : ( */}
                        <>
                          <DataGrid
                            localeText={localeText}
                            rows={sampleRequestDocs}
                            columns={columnsForDoc}
                            className="data-grid upload-doc-datagrid-table"
                            // hideFooterPagination
                            loading={isLoading}
                            hideFooter
                            disableColumnResize
                          />
                        </>
                      {/* )} */}
                    </div>
                  </div>
                </div>
                <div className="col-xl-6 mb-3 mb-xl-0 pe-0 ps-xl-2 ps-0">
                  <div className="recentActivity h-100">
                    <div className="title-bar d-flex justify-content-between align-items-center">
                      <h3 className="mb-0">Recent Activity</h3>
                    </div>
                    <div className="history-stepper-wrapper">
                      <HistoryStepper historyData={historyData} />
                    </div>
                  </div>
                </div>
              </div>
            
            {/* <div className="row mt-5 mb-3 m-0">
              <div className="col-xl-6 mb-3 mb-xl-0">
                <div className="title-bar d-flex justify-content-between align-items-center mb-3">
                  <h3 className="mb-0">List of Documents</h3>
                  <UploadDocs
                    fetchData={fetchData}
                    csvId={id}
                    uploadCSV={false}
                    requestType={"SAMPLE_REQUEST"}
                  />
                </div>
                <div
                  className="inventory-doc-table"
                  style={{ height: 350, width: "100%" }}
                >
                  <DataGrid
                    localeText={localeText}
                    rows={sampleRequestDocs}
                    columns={columnsForDoc}
                    className="data-grid"
                    hideFooterPagination
                  />
                </div>
              </div>
              <div className="col-xl-6 mb-3 mb-xl-0">
                <div className="recentActivity">
                  <div className="title-bar d-flex justify-content-between align-items-center mb-3">
                    <h3 className="mb-2">Recent Activity</h3>
                  </div>
                  <div>
                  <HistoryStepper historyData={historyData} />
                  </div>
                </div>
              </div>
            </div> */}
          </div>
          {(isOpenEditSection || isMessageBoxOpen) && (
            <div className={`msgContainerBox view-sample-msgContainerBox ${isOpenEditSection ? "edit-box-wrapper" :"" }`}>
              {isOpenEditSection && (
                <EditRequest
                  requestType={"SAMPLE_REQUEST"}
                  id={id}
                  refreshData={fetchData}
                  onEditClick={handleEditButtonClick}
                />
              )}
              {isMessageBoxOpen && (
                <ContainerMessageBox
                  requestType={"SAMPLE_REQUEST"}
                  sellerCompanyId={
                    isSeller ? CommonService.getCompanyId() : null
                  }
                  isSeller={isSeller}
                  wrapperHeight={wrapperHeight}
                />
              )}
            </div>
          )}
          {viewBarrelSelection && <BarrelSelectionPanel requestType={Constant.RequestType.SAMPLE_REQUEST} requestId={id} orderItemId={null} inventoryId={sampleRequest?.inventoryId} inventoryName={sampleRequest?.inventoryName} requiredQuantity={sampleRequest.quantity} companyName={sampleRequest.inventoryOwnerCompanyName} currentStatus={sampleRequest.status} handleCloseBarrelSelection={handleCloseBarrelSelection} />}

          {showMessageBox && (
                <div className="admin-message-box">
                  <div
                    className="admin-message-box-left-inner"
                    onClick={handleAdminMessageClick}
                  ></div>
                  <div className="admin-message-box-inner positio-relative" ref={innerRef}>
                    <AdminMessageBox
                      selectedGroup={""}
                      requestId={id}
                      requestType={"SAMPLE_REQUEST"}
                      unreadGroupsCount={unreadGroupsCount}
                      setUnreadGroupsCount={setUnreadGroupsCount}
                      isSeller={isSeller}
                      containerHeight={innerHeight}  // Passing height as a prop
                    />
                  </div>
                </div>
              )}
        </div>
      </div>

      {/* Status Change Model Pop-up */}
      <Modal
        show={show}
        onHide={handleClose}
        className="modal__wd modal__wd--submitSellReq"
      >
        <Modal.Header className="flex-column align-items-start">
          <Modal.Title>Update Sample Request Status</Modal.Title>
          {isApproved && (
            <p className="modal-text mt-2">
              Please Enter Track Number
            </p>
          )}
          {!isApproved && !isBeforeCancel && !isAfterCancel && (
            <p className="modal-text mt-2">
              Are you sure, you want to change status to {formatStatus(statusDetailsRef.current.sampleRequestStatus)}?
            </p>
          )}
          {isBeforeCancel && (
            <p className="modal-text mt-2">
              Are you sure, you want to cancel?
            </p>
          )}
          {isAfterCancel && (
            <p className="modal-text mt-2">
              Are you sure, you want to cancel? A cancellation charge may apply.
            </p>
          )}
        </Modal.Header>

        {["SEND_TO_WAREHOUSE", "IN_TRANSIT", "REJECTED", "CANCELLED"].includes(statusDetailsRef.current.sampleRequestStatus) && (
          <Modal.Body className="pb-1">
          <div className="form__inner pb-0">
            {isApproved && (
              <>
                <label className="modal-body__title mb-1">Track Number</label>
                <Form.Control
                  className={`form-control ${error ? "is_invalid" : ""}`}
                  type="text"
                  value={trackNumberValue}
                  onChange={handleInputChange}
                  placeholder="Enter Tracking Number..."
                />
              </>
            )}
            {isApproved && error && (
              <div className="error-message"> {error}</div>
            )}

            {(isRequestRejected || isBeforeCancel || isAfterCancel) && (
              <textarea
                className={`form-control ${error ? "is_invalid" : ""}`}
                aria-label="With textarea"
                value={rejectionNoteValue}
                onChange={handleInputChange}
                rows={8}
                style={{ resize: "none" }}
                placeholder={(isBeforeCancel || isAfterCancel) ? "Enter Cancellation Note..." : "Enter Rejection Note..."}
              />
            )}
            {!isApproved && error && (
              <div className="error-message"> {error}</div>
            )}

            {isInWarehouse && (
              <div className="form__inner">
                <label className="modal-body__title mb-1">Select Warehouse</label>
                <Select
                  className={`select-company-dropdown form-control w-100 multi-select-dropdown ${error ? "is_invalid" : ""
                    }`}
                  options={warehouseUserList.map((user) => ({
                    value: user.userId,
                    label: user.userName,
                  }))}
                  onChange={handleWarehouseUserChange}
                  components={{
                    DropdownIndicator: () => <ExpandMoreRoundedIcon />,
                    IndicatorSeparator: () => null, // Remove the default separator
                  }}
                  isSearchable
                  placeholder="Select Warehouse"
                />
                {error && <div className="error-message">{error}</div>}
              </div>
            )}

            {isApproved && (<div className="d-flex align-items-center h-100 mt-2">
              <div className="create-ticket-attachement-wrapper d-flex flex-wrap align-items-center gap-1">
                <IconButton
                  type="button"
                  aria-label="submit"
                  sx={{
                    transform: "rotate(45deg)",
                    padding: "8px",
                  }}
                  onClick={handleButtonClick}
                >
                  <AttachFileIcon />
                </IconButton>
                <span className="cursor-pointer" onClick={handleButtonClick}>
                  Upload Document
                </span>
                <div className="d-flex align-items-center gap-2 flex-wrap">
                  {files?.map((file, index) => (
                    <div
                      className="file__upload--info d-flex align-items-center mb-1 me-2"
                      key={index}
                    >
                      <div className="file-name me-3">{file.name}</div>
                      <div className="file-delete">
                        <img
                          src={TrashIcon}
                          alt="TrashIcon"
                          onClick={() => handleDeleteFile(index)}
                        />
                      </div>
                    </div>
                  ))}
                </div>
                <div style={{ position: "relative" }}>
                  <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    multiple
                    onChange={handleFileChange}
                  />
                </div>
              </div>
            </div>
            )}
          </div>
        </Modal.Body>)}

        <Modal.Footer className={`justify-content-center 
          ${["SEND_TO_WAREHOUSE", "IN_TRANSIT", "REJECTED", "CANCELLED"].includes(statusDetailsRef.current.sampleRequestStatus) ? '' : 'bg-transparent'}`}>
          <div className="btn-group row d-flex justify-content-between w-100">
            <div className="col-6 ps-0">
              <button
                className="secondary-btn w-100"
                onClick={handleClose}
                disabled={isSpinner}
              >
                No
              </button>
            </div>

            <div className="col-6 pe-0">
              <button
                className="primary-btn w-100"
                onClick={changeSampleRequestStatus}
                disabled={isSpinner}
              >
                {isSpinner && <Spinner />} {(isBeforeCancel || isAfterCancel) ? "Cancel Request" : (isRequestRejected ? "Reject Request" : "Yes")}
              </button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        show={isOwnerRejected}
        onHide={handleClose}
        className="modal__wd modal__wd--submitSellReq"
      >
        <Modal.Header className="flex-column align-items-start">
          <Modal.Title>Update Owner Status</Modal.Title>

          <p className="modal-text">
            Are you sure, you want to change status to Rejected?
          </p>
        </Modal.Header>

        <Modal.Body className="pb-1">
          <div className="form__inner">
            <textarea
              className={`form-control ${error ? "is_invalid" : ""}`}
              aria-label="With textarea"
              value={ownerRejectionNote}
              onChange={handleOwnerRejectionNote}
              rows={8}
              style={{ resize: "none" }}
              placeholder="Enter Rejection Note..."
            />

            {error && <div className="error-message"> {error}</div>}
          </div>
        </Modal.Body>

        <Modal.Footer className="justify-content-center">
          <div className="btn-group row d-flex justify-content-between w-100">
            <div className="col-6 ps-0">
              <button
                className="secondary-btn w-100"
                onClick={handleClose}
                disabled={isSpinner}
              >
                No
              </button>
            </div>

            <div className="col-6 pe-0">
              <button
                className="primary-btn w-100"
                onClick={changeSampleRequestOwnerStatus}
                disabled={isSpinner}
              >
                {isSpinner && <Spinner />} Reject Request
              </button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ViewSampleRequest;